import { type FragmentType } from '@typings/gql'
import { type FetchSplitSearchResultsQuery } from '@typings/gql/graphql'
import React from 'react'

import { type TabId } from './data'
import { BlogRow, type BlogRowFragment } from './rows/blog-row'
import { FaqRow, type FaqRowFragment } from './rows/faq-row'
import { MarketRow, type MarketRowFragment } from './rows/market-row'
import { ProductRow, type ProductRowFragment } from './rows/product-row'

type Props = {
  data?: FetchSplitSearchResultsQuery
  category: TabId
  inputValue?: string
  fetching?: boolean
  error?: boolean
}

const ResultsMapper = ({
  data,
  category,
  inputValue,
  fetching,
  error,
}: Props) => {
  const response: Record<TabId, any> = {
    PRODUCT: data?.inbentaResponse?.result[0],
    BLOG: data?.inbentaResponse?.result[1],
    FAQ: data?.inbentaResponse?.result[2],
    MARKET: data?.marketResponse?.result,
  }

  if (!response[category]?.items?.length && !fetching) {
    return (
      <p className="text-100 text-amplification-black-premium group-[.is-dark-mode]/menu:text-white-50">
        Aucun élément ne correspond aux terme de recherché “{inputValue}”.
      </p>
    )
  }

  if (error && !fetching) {
    return (
      <p className="text-100 text-amplification-black-premium group-[.is-dark-mode]/menu:text-white-50">
        Une erreur est survenue, veuillez réessayer ultérieurement
      </p>
    )
  }

  switch (category) {
    case 'PRODUCT':
      return (response[category]?.items || []).map(
        (item: FragmentType<typeof ProductRowFragment>, index: number) => (
          <ProductRow
            key={`item-PRODUCT-${index}`}
            content={item}
            searchCode={response[category]?.tracking.searchCode}
          />
        )
      )
    case 'BLOG':
      return (response[category]?.items || []).map(
        (item: FragmentType<typeof BlogRowFragment>, index: number) => (
          <BlogRow
            key={`item-PRODUCT-${index}`}
            content={item}
            searchCode={response[category]?.tracking.searchCode}
          />
        )
      )
    case 'FAQ':
      return (response[category]?.items || []).map(
        (item: FragmentType<typeof FaqRowFragment>, index: number) => (
          <FaqRow
            key={`item-PRODUCT-${index}`}
            content={item}
            searchCode={response[category]?.tracking.searchCode}
          />
        )
      )
    case 'MARKET':
      return (response[category]?.items || []).map(
        (item: FragmentType<typeof MarketRowFragment>, index: number) => (
          <MarketRow key={`item-PRODUCT-${index}`} content={item} />
        )
      )
  }
}

export default ResultsMapper
